<template>
  <div>
    <section class="uk-section-default uk-section uk-padding-remove-vertical">
      <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
        <div class="uk-width-1-1@m uk-first-column">
          <div
            uk-slideshow="ratio: false; animation: pull; velocity: 0.6; autoplay: 1;"
            class="uk-margin uk-text-left uk-slideshow"
          >
            <div class="uk-position-relative">
              <ul
                class="uk-slideshow-items"
                uk-height-viewport="offset-top: true; minHeight: 300;"
              >
                <li tabindex="-1">
                  <div
                    class="uk-position-cover"
                    uk-slideshow-parallax="scale: 1,1.2,1.2"
                  >
                    <img
                      class="uk-cover"
                      uk-img="target: !.uk-slideshow-items"
                      uk-cover
                      src="https://images.pexels.com/photos/1304469/pexels-photo-1304469.jpeg"
                    />
                  </div>
                  <div
                    class="uk-position-cover"
                    uk-slideshow-parallax="opacity: 0.5,0,0; backgroundColor: #000,#000"
                  ></div>
                  <div
                    class="uk-position-cover uk-flex uk-flex-left uk-flex-middle uk-container uk-section"
                  >
                    <div
                      class="uk-panel uk-width-xlarge uk-light uk-margin-remove-first-child"
                      uk-slideshow-parallax="x: 600,0,-600;"
                    >
                      <form>
                        <fieldset class="uk-fieldset">
                          <legend class="uk-h2">Logga in</legend>
                          <div class="uk-margin">
                            <input v-model="password" class="uk-input" type="password" placeholder="Lösenord">
                          </div>
                          <button class="uk-button uk-button-primary dark" @click="login">Logga in</button>
                        </fieldset>
                      </form>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "UC",
  data() {
    return {
      password: "",
    }
  },
  mounted() {
    //
  },
  methods: {
    login() {
      if (this.password === "B123") {
        this.$router.push("/Main");
      }
    },
  }
};
</script>
